export const SET_HIGHLIGHT_REPORTS = 'SET_HIGHLIGHT_REPORTS';
export const CLEAR_HIGHLIGHT_REPORTS = 'CLEAR_HIGHLIGHT_REPORTS';
export const SET_HIGHLIGHT_REPORTS_STATS = 'SET_HIGHLIGHT_REPORTS_STATS';
export const CLEAR_HIGHLIGHT_REPORTS_STATS = 'CLEAR_HIGHLIGHT_REPORTS_STATS';
export const SET_HIGHLIGHT_REPORTS_LOADING = 'SET_HIGHLIGHT_REPORTS_LOADING';
export const SET_HIGHLIGHT_REPORTS_LIST_OPTIONS = 'SET_HIGHLIGHT_REPORTS_LIST_OPTIONS';
export const CLEAR_HIGHLIGHT_REPORTS_LIST_OPTIONS = 'CLEAR_HIGHLIGHT_REPORTS_LIST_OPTIONS';
